<script>
  import NavBar from "./NavBar.svelte";
  import Footer from "./Footer.svelte";
  import SideBar from "./SideBar.svelte";
  import { onMount } from "svelte";
  import { Wave } from "svelte-loading-spinners";
  import loadData from "../utils/loadData";

  let loading = true;

  onMount(async () => {
    await loadData(false).catch((err) => console.log(err));
    loading = false;
  });
</script>

<div
  class={`font-normal min-h-screen flex`}
  style="background-color: #FAFAFA;"
  id="home"
>
  <div style="background-image: url(./images/pattern.svg)">
    <SideBar />

    {#if loading}
      <div
        class="loading-screen h-screen flex items-center justify-center"
        style="background: #FAFAFA"
      >
        <Wave size="100" color="rgb(244,162,97)" unit="px" />
      </div>
    {:else}
      <div class="content">
        <NavBar />
        <div class="w-full pl-4 pr-6">
          <slot />

          <!-- <div
          class="bg-gray-900 text-gray-100 w-screen h-screen fixed top-0 bottom-0 left-0 right-0 flex items-center justify-center text-6xl"
          style="z-index: 9999 !important;"
        >
          💡 UNDER MAINTENANCE
        </div> -->
          <Footer />
        </div>
      </div>
    {/if}
  </div>
</div>

<style>
  .loading-screen {
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    position: fixed;
    z-index: 100 !important;
    top: 0;
    left: 0;
  }
  /* .loading-screen {
    width: calc(100vw - var(--side-menu-width));
    margin-left: var(--side-menu-width);
  } */
</style>
